/**
 * 选科/科类联动
 *
 * 3+1+2 新高考(2025 起陕西):学生必须选 1 首选 + 2 次选,合计 3 科
 * - 物理类:物 + 2 选自{化,生,政,地},C(4,2) = 6 种
 * - 历史类:史 + 2 选自{化,生,政,地},C(4,2) = 6 种
 *
 * UI 改完后,后端 cloud-functions/lib/subject-compat.ts 的 SUBJECT_COMPAT
 * 表也要同步改(那个表是 SQL IN 子句的预计算)
 */
export const SUBJECTS: Record<string, string[]> = {
  '物理类': [
    '物+化+生', '物+化+政', '物+化+地',
    '物+生+政', '物+生+地', '物+政+地',
  ],
  '历史类': [
    '史+化+生', '史+化+政', '史+化+地',
    '史+生+政', '史+生+地', '史+政+地',
  ],
}
